export default ".lu {\n  clear: both;\n  position: absolute;\n  top: 1px;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 0;\n}\n"